export default {
	media: {},
	alert: {
		show: false,
		text: "",
		timeout: 3000
	}
};
